import type {
    ContactSearchEntry,
    RevealedContactSearchEntry,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

import { isContactSearchEntryRevealed } from "./isContactSearchEntryRevealed";

export const isRevealedContactSearchEntryType = (v: ContactSearchEntry): v is RevealedContactSearchEntry =>
    isContactSearchEntryRevealed(v);
